import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Shield } from 'lucide-react';

export const HeroSection = ({ onContactClick }) => {
  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-20 bg-gradient-to-br from-emerald-50 via-white to-amber-50">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="inline-flex items-center bg-emerald-100 text-emerald-800 px-4 py-2 rounded-full text-sm font-semibold">
              <Shield className="h-4 w-4 mr-2" />
              USPTO Filing Experts
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-emerald-900 leading-tight">
              Protect Your Brand with{' '}
              <span className="text-amber-600">Federal Trademark Registration</span>
            </h1>
            
            <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
              Secure exclusive rights to your brand name, logo, and identity. Our expert team handles the entire USPTO trademark registration process, ensuring your business is legally protected nationwide.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                onClick={onContactClick}
                size="lg"
                className="bg-emerald-700 hover:bg-emerald-800 text-white font-semibold px-8 py-6 text-lg transition-all duration-300 shadow-lg hover:shadow-xl"
              >
                Register My Trademark
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
              <Button
                onClick={onContactClick}
                size="lg"
                variant="outline"
                className="border-2 border-amber-600 text-amber-700 hover:bg-amber-50 font-semibold px-8 py-6 text-lg transition-all duration-300"
              >
                Free Consultation
              </Button>
            </div>

            {/* Trust Indicators */}
            <div className="grid grid-cols-3 gap-6 pt-8">
              <div className="text-center">
                <div className="text-3xl font-bold text-emerald-800">1000+</div>
                <div className="text-sm text-gray-600 mt-1">Trademarks Filed</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-emerald-800">98%</div>
                <div className="text-sm text-gray-600 mt-1">Success Rate</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-emerald-800">24 Hrs</div>
                <div className="text-sm text-gray-600 mt-1">Fast Processing</div>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1758519288480-1489c17b1519"
                alt="Professional trademark registration services"
                className="w-full h-[600px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-emerald-900/40 to-transparent"></div>
            </div>
            
            {/* Floating Card */}
            <div className="absolute bottom-8 left-8 right-8 bg-white rounded-xl shadow-xl p-6">
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-sm text-gray-600 mb-1">Starting from</div>
                  <div className="text-3xl font-bold text-emerald-800">$45</div>
                  <div className="text-sm text-gray-500">+ Federal Filing Fee</div>
                </div>
                <Button
                  onClick={onContactClick}
                  className="bg-amber-600 hover:bg-amber-700 text-white font-semibold transition-all duration-300"
                >
                  Get Started
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
